module.exports = __webpack_public_path__ + "img/logo_heyway_koksgrå_rgb.3751c524.png";